import React, { Component } from "react";
import { connect } from "react-redux";

import FirstScreen from "./FirstScreen";
import Home from "./Home";
import MainPage from "./MainPage";
import Loading from "../helpers/loading";
import { getPopularLocations } from "../../services/popularLocations/actions";

class Mobile extends Component {
    state = {
        showGdpr: false,
        defaultLocationRequested: false,
        defaultLocationSet: false,
    };

    componentDidMount() {
        setTimeout(() => {
            if (document.getElementsByClassName("popup-content")[0]) {
                document.getElementsByClassName("popup-content")[0].style.backgroundColor = "transparent";
            }
        }, 100);

        if (!localStorage.getItem("gdprAccepted")) {
            localStorage.setItem("gdprAccepted", "false");
            if (localStorage.getItem("showGdpr") === "true") {
                this.setState({ showGdpr: true });
            }
        }

        if (localStorage.getItem("showGdpr") === "true" && localStorage.getItem("gdprAccepted") === "false") {
            this.setState({ showGdpr: true });
        }

        // Skip FirstScreen: when no location, use store default or fetch from API
        if (!localStorage.getItem("userSetAddress")) {
            // First check if store has default location from config
            const storeDefaultLocationStr = localStorage.getItem("storeDefaultLocation");
            if (storeDefaultLocationStr) {
                try {
                    const storeDefaultLocation = JSON.parse(storeDefaultLocationStr);
                    if (storeDefaultLocation.latitude && storeDefaultLocation.longitude) {
                        const userSetAddress = {
                            lat: storeDefaultLocation.latitude,
                            lng: storeDefaultLocation.longitude,
                            address: storeDefaultLocation.address || storeDefaultLocation.name || "Store Location",
                            house: null,
                            tag: null,
                            city: null,
                            state: null,
                            businessLocation: true,
                        };
                        localStorage.setItem("userSetAddress", JSON.stringify(userSetAddress));
                        localStorage.setItem("userAlreadySelectedLocation", "true");
                        this.setState({ defaultLocationSet: true, defaultLocationRequested: false });
                        return;
                    }
                } catch (e) {
                    console.error("Error parsing storeDefaultLocation:", e);
                }
            }
            
            // Fallback: fetch from popular locations API
            this.setState({ defaultLocationRequested: true });
            this.props.getPopularLocations();
            this.defaultLocationTimeout = setTimeout(() => {
                this.setState((s) => {
                    if (!s.defaultLocationSet && s.defaultLocationRequested) {
                        return { defaultLocationRequested: false };
                    }
                    return null;
                });
            }, 8000);
        }
    }

    componentWillUnmount() {
        if (this.defaultLocationTimeout) clearTimeout(this.defaultLocationTimeout);
    }

    componentDidUpdate(prevProps) {
        const { popular_locations } = this.props;
        const { defaultLocationRequested, defaultLocationSet } = this.state;

        if (localStorage.getItem("userSetAddress")) return;
        if (!defaultLocationRequested || defaultLocationSet) return;

        // First, try to use store default location from store config
        const storeDefaultLocationStr = localStorage.getItem("storeDefaultLocation");
        if (storeDefaultLocationStr) {
            try {
                const storeDefaultLocation = JSON.parse(storeDefaultLocationStr);
                if (storeDefaultLocation.latitude && storeDefaultLocation.longitude) {
                    const userSetAddress = {
                        lat: storeDefaultLocation.latitude,
                        lng: storeDefaultLocation.longitude,
                        address: storeDefaultLocation.address || storeDefaultLocation.name || "Store Location",
                        house: null,
                        tag: null,
                        city: null,
                        state: null,
                        businessLocation: true,
                    };
                    localStorage.setItem("userSetAddress", JSON.stringify(userSetAddress));
                    localStorage.setItem("userAlreadySelectedLocation", "true");
                    this.setState({ defaultLocationSet: true, defaultLocationRequested: false });
                    return;
                }
            } catch (e) {
                console.error("Error parsing storeDefaultLocation:", e);
            }
        }

        // Fallback to popular locations API
        if (!popular_locations || popular_locations.length === 0) {
            return;
        }

        const defaultLocation = popular_locations.find(loc => loc.is_default === 1 || loc.is_default === true)
            || popular_locations[0];

        if (defaultLocation) {
            const userSetAddress = {
                lat: defaultLocation.latitude,
                lng: defaultLocation.longitude,
                address: defaultLocation.name,
                house: null,
                tag: null,
                city: null,
                state: null,
                businessLocation: true,
            };
            localStorage.setItem("userSetAddress", JSON.stringify(userSetAddress));
            localStorage.setItem("userAlreadySelectedLocation", "true");
            this.setState({ defaultLocationSet: true, defaultLocationRequested: false });
        }
    }

    handleGdprClick = () => {
        localStorage.setItem("gdprAccepted", "true");
        this.setState({ showGdpr: false });
    };

    render() {
        const hasLocation = localStorage.getItem("userSetAddress");
        const { defaultLocationRequested, defaultLocationSet } = this.state;

        const loadingDefault = !hasLocation && defaultLocationRequested && !defaultLocationSet;

        return (
            <React.Fragment>
                {this.state.showGdpr && (
                    <div className="fixed-gdpr-mobile">
                        <span
                            dangerouslySetInnerHTML={{
                                __html: localStorage.getItem("gdprMessage"),
                            }}
                        />
                        <span>
                            <button
                                className="btn btn-sm ml-2"
                                style={{ backgroundColor: localStorage.getItem("storeColor") }}
                                onClick={this.handleGdprClick}
                            >
                                {localStorage.getItem("gdprConfirmButton")}
                            </button>
                        </span>
                    </div>
                )}
                {hasLocation ? (
                    <div>
                        <MainPage languages={this.props.languages} />
                    </div>
                ) : loadingDefault ? (
                    <Loading />
                ) : (
                    <FirstScreen languages={this.props.languages} />
                )}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    popular_locations: state.popular_locations.popular_locations,
});

export default connect(mapStateToProps, { getPopularLocations })(Mobile);